


import { Injectable } from '@angular/core';
import { Department } from '@app/shared/models/admin/department';
import { Service } from '@app/shared/models/admin/service';
import { HttpClientService } from 'app/core/http-client/http-client.service';
import { services } from 'app/core/settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageServiceService {

  private static readonly endpoint = 'Services';
  constructor(private http: HttpClientService) { }

  getAll(): Observable<any> {
    return this.http.get(`${ManageServiceService.endpoint}/GetAllServices`, undefined, services.orderService)
  }

  list(body: any) {
    return this.http.post(body, `${ManageServiceService.endpoint}/GetServicePagginatedList`, undefined, services.orderService)
  }

  create(model: Object): Observable<any> {
    return this.http.postFormData(model, `${ManageServiceService.endpoint}/Create`, undefined, services.orderService);
  }

  update(model: object): Observable<any> {
    return this.http.putFormData(model, `${ManageServiceService.endpoint}/Update`, undefined, services.orderService);
  }

  delete(id: number) {
    return this.http.delete<boolean>(`${ManageServiceService.endpoint}/Delete/${id}`, undefined, services.orderService);
  }
}
